import { Fragment, memo } from 'react';
import PropTypes from 'prop-types';

import { Radio, RadioGroup } from 'basic-components';
import { CommonEnums } from 'dashboard-services';

const ContractSort = ({ value, onChange }) => (
  <Fragment>
    <div 
        className="ng-office-app__authed__content__body__item__expanded-settings__bottom__label"
        style={{ marginTop: 12 }}
    >
      Contract sort order
    </div>
    <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__value ng-office-app__authed__content__body__item__expanded-settings__bottom__value--radio">
      <RadioGroup
          name="contractSort"
          onChange={onChange}
          selectedValue={value}
      >
        <Radio name={CommonEnums.SORT_ORDER.ASCENDING}>
          Ascending
        </Radio>
        <Radio name={CommonEnums.SORT_ORDER.DESCENDING}>
          Descending
        </Radio>
      </RadioGroup>
    </div>
  </Fragment>
)

ContractSort.defaultProps = {
  value: undefined,
}

ContractSort.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
}

export default memo(ContractSort)